import { Collapse, CollapseProps } from 'antd';
import classNames from 'classnames';

const MCollapse: React.FC<CollapseProps> = (props) => {
  return (
    <Collapse
      {...props}
      expandIconPosition="end"
      bordered={false}
      className={classNames('trojan-collapse', props.className)}
    />
  );
};

export default MCollapse;
